// extracted by mini-css-extract-plugin
export default {"Icon":"ImageCaption_Icon__YWY1N"};